function encodeQueryData(data: Record<string, any>) {
  return Object.keys(data)
    .map(
      (key) =>
        `${encodeURIComponent(key)}=${
          //eslint-disable-next-line no-eq-null
          data[key] == null ? '' : data[key]
        }`, //todo encodeURIComponent
    )
    .join('&');
}

export class UrlBuilder {
  params: Record<string, any>;
  _base: string;
  constructor(baseUrl: string, params?: Record<string, any>) {
    this._base = baseUrl;
    this.params = params || {};
  }

  base(baseUrl: AnyFixMe) {
    this._base = baseUrl;
    return this;
  }

  param(name: AnyFixMe, value: AnyFixMe) {
    this.params[name] = value;
    return this;
  }

  ifParam(condition: AnyFixMe, name: AnyFixMe, value: AnyFixMe) {
    if (condition) {
      return this.param(name, value);
    }
    return this;
  }

  paramsObj(params: AnyFixMe) {
    this.params = { ...this.params, ...params };
    return this;
  }

  url() {
    let query = encodeQueryData(this.params);
    if (query) {
      query = `?${query}`;
    }
    return this._base + query;
  }
}
